import Services from '../../services';

class HargaPerkiraanSendiriApi {
  getPage(page, dataLength, key) {
    return Services.get(
      `/hrdu/harga_perkiraan_sendiri/page?page=${page}&per_page=${dataLength}&q=${key}`
    );
  }

  page(params) {
    return Services.get(`/hrdu/harga_perkiraan_sendiri/page?`, { params });
  }

  update(data) {
    return Services.post('/hrdu/harga_perkiraan_sendiri', data);
  }
}

export default new HargaPerkiraanSendiriApi();
